module.exports = __webpack_public_path__ + "media/images/web/favicon/favicon-16x16-dd448a1e868dff4d7a6e3431847582ef.png";